import firebase from 'firebase'

export const getInitials = name => {
  var parts = name.split(' ')
  var initials = ''
  for (var i = 0; i < parts.length; i++) {
    if (parts[i].length > 0 && parts[i] !== '') {
      initials += parts[i][0]
    }
  }
  return initials.toUpperCase()
}

export const truncateText = (text, maxLength) => {
  if (text.length > maxLength) {
    return text.slice(0, maxLength)
  } else {
    return text
  }
}

export const checkUserLogin = async () => {
  return new Promise(resolve => {
    firebase.auth().onAuthStateChanged(user => {
      resolve(!!user)
    })
  })
}

// Example usage
//import { trackEvent } from '@/helpers/functions'
//trackEvent('click', 'outbound_link', 'https://example.com', 'Link Text');
// or for ad clicks
//trackEvent('click', 'advertisement', 'sidebar_ad', 'Ad Campaign Name');
export const trackEvent = (eventName, category, label, value) => {
  // Google Analytics event
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', eventName, {
      event_category: category,
      event_label: label,
      value: value
    })
  }
  // Meta Pixel event (using standard event names where applicable)
  // Note: Meta Pixel uses different event names, so this is a generic tracking
  // For specific Meta events, use fbq('track', 'EventName') directly
  if (typeof window.fbq !== 'undefined') {
    // Map common Google Analytics events to Meta Pixel events
    const metaEventMap = {
      conversion: 'Purchase',
      sign_up: 'CompleteRegistration',
      login: 'Lead'
    }
    const metaEventName = metaEventMap[eventName] || eventName
    window.fbq('track', metaEventName, {
      content_name: label,
      content_category: category,
      value: value
    })
  }
}
